<div class="container">

    <div class="row">
        <div class="col-6 offset-3 mt-5 pt-3">
            <app-value-widget [title]="'I am title'" [value]="getValue()"></app-value-widget>
            <app-value-widget [title]="'I am title'" [value]="getValue()" [iconType]="getIcon()"></app-value-widget>
        </div>
    </div>
</div>
